import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ensureCatalogHierarchy } from '../actions/catalogActions';

// Reading the slice through this hook also lazy-loads it, so the fetch can't be forgotten.
// Prefer this over selecting `state.catalog` directly.
export const useCatalogHierarchy = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(ensureCatalogHierarchy());
  }, [dispatch]);

  return useSelector(state => state.catalog);
};
